// * ========================================================================
// * Filter news
// * ========================================================================

'use strict';

import $ from 'jquery';

var filterNews = (function() {
  function init(){

    var $inputs = $('[data-filterfor]');

    $inputs.on('change', function(){
      var filters = {checkboxes: [], selects: []};
      var $newsItems = $('.js-newslist__list-item');
      $inputs.each(function(){
        var filter = $(this).attr('data-filterfor');
        var val = $(this).val();

        if($(this).is(':checkbox')){
          if($(this).is(':checked')) {
            filters.checkboxes.push({filter: filter, value: val});
          }
        }
        else if($(this).is('select')){
          if(val !== ''){
            filters.selects.push({filter: filter, value: val});
          }
        }
      });

      //hide news until filter function
      $newsItems.hide();

      $newsItems.filter(function(){
        var element = $(this);
        var found = false;

        if(filters.checkboxes.length){
          $.each(filters.checkboxes, function(){
            if(element.attr('data-filter-type').indexOf(this.value) > -1) {
              found = true;
              //return false;
            }
          });
        }
        //if machine is selected, get all machine related news
        if(filters.selects.length && filters.selects.length > 0 ){
          $.each(filters.selects, function(){
            if(element.attr('data-filter-relatedmachines').indexOf(this.value) > -1) {
              found = true;
            }
          });
        }
        return found;
      }).show();
      //reset news filter
      if(filters.checkboxes.length === 0 && filters.selects.length ===0 ) $newsItems.show();
    });

  }
  return {
    init: init
  }
})();

module.exports = filterNews;
